// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCFjlvpcbyinYI35cCrcEgwkkq6zlqcgD8",
  authDomain: "thehousehawk-b7691.firebaseapp.com",
  databaseURL: "https://thehousehawk-b7691-default-rtdb.firebaseio.com",
  projectId: "thehousehawk-b7691",
  storageBucket: "thehousehawk-b7691.appspot.com",
  messagingSenderId: "399518303746",
  appId: "1:399518303746:web:0f1fe528ef6225a5bbc91b",
  measurementId: "G-DWKMGR8VEP",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getDatabase(app);
export const firestore = getFirestore(app);
